/**
 * @param controlTime - The Time In Miliseconds comparing to (Should be first Time)
 * @param variantTime - The variant Time in Miliseconds to Compare Agaisnt control
 * @return {Number} - Returns The Amount of Miliseconds that have passed Between Variant and Control time.
 */
export const difInMiliSeconds = (controlTime, variantTime) => {
  return variantTime - controlTime;
}


/**
 *
 * @param ms - Amount of Miliseconds
 * @return {string} - Returns a formatted String of hh:mm:ss Of time left.
 */
export const convertMS = (ms) => {
  var d, h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;
  d = Math.floor(h / 24);
  h = h % 24;
  h += d * 24;

  if(d<0 && h<0 && m<0 && s<0) {
    return "00 : 00 : 00";
  }

  h = h < 10 ? '0'+ h : h;
  m = m < 10 ? '0'+ m : m;
  s = s < 10 ? '0'+ s : s;

  return h + ' : ' + m + ' : ' + s;
}
